import React from 'react';

interface TableColumnConfig<T> {
  key: keyof T;
  header: any;
  render?: (data: T[keyof T], rowData?: T, rowIndex?: number) => any;
}

interface TableProps<T> {
  columns: TableColumnConfig<T>[];
  data: T[];
  designTable?: boolean;
  alignTextTop?: boolean;
}
const Table = <T,>({ columns, data, designTable = true, alignTextTop }: TableProps<T>) => {
  function renderValue(value: any): any {
    if (React.isValidElement(value)) {
      return value;
    } else if (typeof value === 'object') {
      return JSON.stringify(value);
    } else if (typeof value === 'string') {
      // Add a space before each capital letter except the first
      return value.replace(/([a-z])([A-Z])/g, '$1 $2');
    } else {
      return value;
    }
  }
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full">
        <thead className="border-b bg-[#D9D9D9] text-sm">
          <tr>
            {columns.map(({ header }, index) => (
              <th key={index} className="p-3 text-left text-13 font-semibold">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={`border-b border-silverGray ${designTable && rowIndex % 2 !== 0 ? 'bg-lightSilver' : ''}`}
            >
              {columns.map(({ key, render }, colIndex) => (
                <td
                  key={colIndex}
                  className={`p-3 text-14 font-normal ${colIndex <= 2 ? 'gbmask' : ''} ${
                    alignTextTop ? 'align-top' : ''
                  }`}
                >
                  {render ? render(row[key], row, rowIndex) : renderValue(row[key] ?? 'N/A')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export { Table };
export type { TableColumnConfig };
